import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationSkipped,
  NavigationStart,
} from '@angular/router';

/**
 * Flags router navigations that are a history traversal (BACK / FORWARD) onto the URL already
 * showing — e.g. the FRC-749 investor bottom sheet pushing and popping its own same-URL entry.
 * With `onSameUrlNavigation: 'reload'` these still emit NavigationStart / NavigationEnd, but nothing
 * changed on screen, so page-change side effects (scroll to top, the navbar's scroll stack, GTM
 * page_view) must not run for them.
 *
 * One instance per subscriber; feed it every router event, in order.
 */
export class SameUrlTraversalTracker {
  private lastUrl: string | undefined;
  private inSameUrlTraversal = false;

  /** True for the NavigationStart and the NavigationEnd of a same-URL popstate traversal. */
  check(event: Event): boolean {
    if (event instanceof NavigationStart) {
      this.inSameUrlTraversal =
        event.navigationTrigger === 'popstate' && event.url === this.lastUrl;
      return this.inSameUrlTraversal;
    }

    if (event instanceof NavigationEnd) {
      const sameUrl = this.inSameUrlTraversal;
      this.inSameUrlTraversal = false;
      this.lastUrl = event.urlAfterRedirects;
      return sameUrl;
    }

    if (
      event instanceof NavigationCancel ||
      event instanceof NavigationError ||
      event instanceof NavigationSkipped
    ) {
      this.inSameUrlTraversal = false;
    }
    return false;
  }
}
